module.exports = __webpack_public_path__ + "static/Apercu-Italic-e823ac5420c676725884fe79c14620df.eot";